<template>
    <div>
        <keep-alive :include="/searchForm/" :max="2">
            <router-view />
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: "RT"
};
</script>



// WEBPACK FOOTER //
// src/components/RouterView/index.vue